<script>
import Banner from '../components/PageBanner';
import TabMenu from '../components/PageTabMenu';
import Tab from '../components/PageTab';
import Footer from '../components/Footer';

export default {
  name: 'PageProjets',
  components :{
    Banner,
    TabMenu,
    Tab,
    Footer,
  }
}
</script>

    Footer
<template>
    <div class="page-main">
      <Banner bannerImage="bannerProjets"/>
      <TabMenu>
        <template v-slot:body>
          <Tab text="Projets"  route="/projets"/>
        </template>
      </TabMenu>

      <div class="page-main-container">
        <router-view></router-view>
      </div>

      <Footer />
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

@include page-main;


</style>
